import React, {ReactElement, RefObject} from "react";
import {v4 as uuidv4} from "uuid";

import {FormGroupBase} from "/src/types";

import {css} from "/src/utils/utils";

import Label from "../label/Label";
import ErrorMessage from "../error-message/ErrorMessage";
import Checkbox from "../checkbox/Checkbox";

import * as styles from "./single-select.module.scss";

interface SingleSelectOption {
  label: string;
  value: string;
}

interface SingleSelectProps extends FormGroupBase {
  onChange?: (str: string) => unknown;
  options: Array<SingleSelectOption>;
  transparentBg?: boolean;
  parentRef?: RefObject<HTMLElement>;
  updateConditionState?: (str1: string, str2: string) => unknown;
}

const SingleSelect = (props: SingleSelectProps): ReactElement => {
  const {
    label = "",
    name,
    required = false,
    value = "",
    errorMessage = "",
    status,
    disabled = false,
    onChange,
    options,
    readOnly,
    darkMode = false,
    transparentBg = false,
    updateConditionState,
  } = props;

  const [selectedValue, setSelectedValue] = React.useState<string>();

  const isInvalid = status === "error";

  React.useEffect(() => {
    setSelectedValue(value || "");
  }, [value]);

  const handleCheckboxChange = (checkboxValue: string) => {
    let temp = selectedValue ? selectedValue : "";
    if (temp !== checkboxValue) {
      temp = checkboxValue;
    }

    setSelectedValue(temp);

    if (
      updateConditionState &&
      checkboxValue !== null &&
      checkboxValue !== undefined
    ) {
      updateConditionState(name, checkboxValue);
    }

    if (onChange) {
      onChange(temp);
    }
  };

  return (
    <div
      className={css(
        styles.singleSelect,
        darkMode ? styles.singleSelectDark : "",
        transparentBg ? styles.singleSelectTransparent : ""
      )}
    >
      <fieldset className={css(styles.singleSelect__fieldset)}>
        <legend>
          <Label
            darkMode={darkMode}
            disabled={disabled}
            label={label}
            required={required}
          />
        </legend>

        <ul className={css(styles.singleSelect__list)}>
          {options &&
            options.map((option: SingleSelectOption) => {
              const checked = selectedValue === option.value;
              return (
                <Checkbox
                  key={`$$checkbox-item-${
                    option.value != null ? option.value : uuidv4()
                  }`}
                  name=""
                  label={option.label}
                  value={option.value}
                  onChange={handleCheckboxChange}
                  isPill
                  darkMode={darkMode}
                  checked={checked}
                  status={status}
                  disabled={disabled}
                  readOnly={readOnly}
                  classes={styles.singleSelect__checkbox}
                />
              );
            })}
        </ul>
      </fieldset>
      <ErrorMessage message={errorMessage} visible={isInvalid} />
    </div>
  );
};

export default SingleSelect;
